import { render, staticRenderFns } from "./DownloadTables.vue?vue&type=template&id=60670c1e&"
import script from "./DownloadTables.vue?vue&type=script&lang=js&"
export * from "./DownloadTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports